import { tokens } from "../design-system/tokens";

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export const IconDot = ({
  width = 11,
  height = 11,
  color = tokens.colors.basics[1800],
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
    >
      <circle cx="6.5" cy="6.5" r="5.5" fill="none"
        stroke={color} 
        strokeWidth="2" />
    </svg>
  );
};